import React from "react";

function CustomLoader() {
    return (
        <div>
            <div className="dotloader" />
        </div>

    )
}

export default CustomLoader;